import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "setting/page-view"

class service {


    //Obtem listagem de campos, já remove da listagem a coluna status e somente registros ativos
    //DEVERÁ SEMPRE INFORMAR A PÁGINA ORIGINAL SEM OVERRIDE
    async getViewFieldsByPage(pageId,removeColumnStatus = false, removerOtherColumns = null){

        let params = new URLSearchParams()
        params.set("pageId", pageId)
        params.set("checkOverride", "true") //ESTE MÉTODO É USADO PARA PESQUISAR SEM ESTAR NA PRÓPRIA PÁGINA, POR TANTO SEMPRE MANTER ESTE PARAM

        let list = []

        await http.list(path + "/viewFields",params).then((result) =>{

            if(removeColumnStatus || removerOtherColumns !== null){

                for(let item of result){

                    let enableInsert = true

                    if(removerOtherColumns !== null){
                        if(removerOtherColumns.indexOf(item.key) >= 0){
                            enableInsert = false
                        }
                    }

                    if(item.key !== 'status' && removeColumnStatus && enableInsert){
                        list.push(item)
                    }
                }

            }

        })

        return list
    }

}

export default new service();

